var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        [
          _vm.edit
            ? [_vm._v("Edit Autoresponder")]
            : [_vm._v("Create New Autoresponder")]
        ],
        2
      ),
      _c(
        "gg-card-text",
        [
          _c(
            "v-form",
            {
              on: {
                submit: function submit($event) {
                  $event.preventDefault()
                  return _vm.newResponder($event)
                }
              }
            },
            [
              _c(
                "v-container",
                {
                  attrs: {
                    fluid: ""
                  }
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pb-0",
                          attrs: {
                            cols: "12",
                            sm: "6"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.rules.email,
                                expression: "rules.email"
                              }
                            ],
                            attrs: {
                              outlined: "",
                              label: "Email",
                              placeholder: "For example: info",
                              type: "email",
                              "data-vv-name": "email",
                              "data-vv-as": "Email",
                              "error-messages": _vm.errors.collect("email")
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "append",
                                fn: function fn() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "append-bg"
                                      },
                                      [
                                        _c("domain-select", {
                                          staticStyle: {
                                            "margin-top": "10px"
                                          },
                                          attrs: {
                                            "no-label": "",
                                            "hide-details": "",
                                            solo: "",
                                            flat: "",
                                            remote_domain: _vm.model.domain,
                                            "prepend-inner-icon": "mdi-at"
                                          },
                                          model: {
                                            value: _vm.model.domain,
                                            callback: function callback($$v) {
                                              _vm.$set(_vm.model, "domain", $$v)
                                            },
                                            expression: "model.domain"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ]),
                            model: {
                              value: _vm.model.email,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "email", $$v)
                              },
                              expression: "model.email"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "pb-0",
                          attrs: {
                            cols: "12",
                            sm: "6"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.rules.from,
                                expression: "rules.from"
                              }
                            ],
                            attrs: {
                              placeholder: "From",
                              outlined: "",
                              label: "From",
                              "data-vv-name": "from",
                              "data-vv-as": "From",
                              "error-messages": _vm.errors.collect("from")
                            },
                            model: {
                              value: _vm.model.from,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "from", $$v)
                              },
                              expression: "model.from"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "py-0",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.rules.subject,
                                expression: "rules.subject"
                              }
                            ],
                            attrs: {
                              placeholder: "Subject",
                              outlined: "",
                              label: "Subject",
                              "data-vv-name": "subject",
                              "data-vv-as": "Subject",
                              "error-messages": _vm.errors.collect("subject")
                            },
                            model: {
                              value: _vm.model.subject,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "subject", $$v)
                              },
                              expression: "model.subject"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "py-0",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-block pb-2"
                            },
                            [_vm._v("Body")]
                          ),
                          _c("v-textarea", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.rules.body,
                                expression: "rules.body"
                              }
                            ],
                            attrs: {
                              placeholder: "Body",
                              dense: "",
                              outlined: "",
                              "hide-details": "",
                              "data-vv-name": "body",
                              "data-vv-as": "Message body",
                              "error-messages": _vm.errors.collect("body")
                            },
                            model: {
                              value: _vm.model.body,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "body", $$v)
                              },
                              expression: "model.body"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "pt-0 pb-6",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              label: "This message contains HTML",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.model.isHtml,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "isHtml", $$v)
                              },
                              expression: "model.isHtml"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-block pb-2"
                            },
                            [_vm._v(" Select Start Date & Time ")]
                          ),
                          _vm.model.start
                            ? _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12",
                                        md: "3"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "close-on-content-click": false,
                                            "nudge-right": 40,
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "min-width": "auto"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function fn(_ref) {
                                                  var on = _ref.on,
                                                    attrs = _ref.attrs
                                                  return [
                                                    _c(
                                                      "gg-text-field",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required",
                                                                expression:
                                                                  "'required'"
                                                              }
                                                            ],
                                                            attrs: {
                                                              placeholder:
                                                                "Select Start Date",
                                                              "prepend-icon":
                                                                "mdi-calendar",
                                                              readonly: "",
                                                              "data-vv-name":
                                                                "Start Date",
                                                              "data-vv-as":
                                                                "Start Date",
                                                              "error-messages": _vm.errors.collect(
                                                                "Start Date"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.dateStart
                                                                  .date,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.dateStart,
                                                                  "date",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "dateStart.date"
                                                            }
                                                          },
                                                          "gg-text-field",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      )
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3169923404
                                          ),
                                          model: {
                                            value: _vm.dateStartModal,
                                            callback: function callback($$v) {
                                              _vm.dateStartModal = $$v
                                            },
                                            expression: "dateStartModal"
                                          }
                                        },
                                        [
                                          _c("v-date-picker", {
                                            staticClass: "picker-td",
                                            attrs: {
                                              min: _vm.currentDate
                                            },
                                            on: {
                                              input: function input($event) {
                                                _vm.dateStartModal = false
                                              }
                                            },
                                            model: {
                                              value: _vm.dateStart.date,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.dateStart,
                                                  "date",
                                                  $$v
                                                )
                                              },
                                              expression: "dateStart.date"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12",
                                        md: "3"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          ref: "startTime",
                                          attrs: {
                                            "close-on-content-click": false,
                                            "nudge-right": 40,
                                            "return-value": _vm.dateStart.time,
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "max-width": "290px",
                                            "min-width": "290px"
                                          },
                                          on: {
                                            "update:returnValue": function updateReturnValue(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dateStart,
                                                "time",
                                                $event
                                              )
                                            },
                                            "update:return-value": function updateReturnValue(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dateStart,
                                                "time",
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function fn(_ref2) {
                                                  var on = _ref2.on,
                                                    attrs = _ref2.attrs
                                                  return [
                                                    _c(
                                                      "gg-text-field",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required",
                                                                expression:
                                                                  "'required'"
                                                              }
                                                            ],
                                                            attrs: {
                                                              placeholder:
                                                                "Select Start Time",
                                                              "prepend-icon":
                                                                "mdi-clock-outline",
                                                              readonly: "",
                                                              "data-vv-name":
                                                                "Start Time",
                                                              "data-vv-as":
                                                                "Start Time",
                                                              "error-messages": _vm.errors.collect(
                                                                "Start Time"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.dateStart
                                                                  .time,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.dateStart,
                                                                  "time",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "dateStart.time"
                                                            }
                                                          },
                                                          "gg-text-field",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      )
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            510942650
                                          ),
                                          model: {
                                            value: _vm.timeStartModal,
                                            callback: function callback($$v) {
                                              _vm.timeStartModal = $$v
                                            },
                                            expression: "timeStartModal"
                                          }
                                        },
                                        [
                                          _vm.timeStartModal
                                            ? _c("v-time-picker", {
                                                attrs: {
                                                  "full-width": ""
                                                },
                                                on: {
                                                  "click:minute": function clickMinute(
                                                    $event
                                                  ) {
                                                    return _vm.$refs.startTime.save(
                                                      _vm.dateStart.time
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _vm.dateStart.time,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.dateStart,
                                                      "time",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "dateStart.time"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-block pb-2"
                            },
                            [_vm._v(" Select End Date & Time ")]
                          ),
                          _vm.model.stop
                            ? _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12",
                                        md: "3"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "close-on-content-click": false,
                                            "nudge-right": 40,
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "min-width": "auto"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function fn(_ref3) {
                                                  var on = _ref3.on,
                                                    attrs = _ref3.attrs
                                                  return [
                                                    _c(
                                                      "gg-text-field",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required",
                                                                expression:
                                                                  "'required'"
                                                              }
                                                            ],
                                                            attrs: {
                                                              placeholder:
                                                                "Select Stop Date",
                                                              "prepend-icon":
                                                                "mdi-calendar",
                                                              readonly: "",
                                                              "data-vv-name":
                                                                "Stop Date",
                                                              "data-vv-as":
                                                                "Stop Date",
                                                              "error-messages": _vm.errors.collect(
                                                                "Stop Date"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.dateEnd
                                                                  .date,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.dateEnd,
                                                                  "date",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "dateEnd.date"
                                                            }
                                                          },
                                                          "gg-text-field",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      )
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3527039907
                                          ),
                                          model: {
                                            value: _vm.dateEndModal,
                                            callback: function callback($$v) {
                                              _vm.dateEndModal = $$v
                                            },
                                            expression: "dateEndModal"
                                          }
                                        },
                                        [
                                          _c("v-date-picker", {
                                            staticClass: "picker-td",
                                            attrs: {
                                              min: _vm.currentDate
                                            },
                                            on: {
                                              input: function input($event) {
                                                _vm.dateEndModal = false
                                              }
                                            },
                                            model: {
                                              value: _vm.dateEnd.date,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.dateEnd,
                                                  "date",
                                                  $$v
                                                )
                                              },
                                              expression: "dateEnd.date"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12",
                                        md: "3"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          ref: "endTime",
                                          attrs: {
                                            "close-on-content-click": false,
                                            "nudge-right": 40,
                                            "return-value": _vm.dateEnd.time,
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "max-width": "290px",
                                            "min-width": "290px"
                                          },
                                          on: {
                                            "update:returnValue": function updateReturnValue(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dateEnd,
                                                "time",
                                                $event
                                              )
                                            },
                                            "update:return-value": function updateReturnValue(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dateEnd,
                                                "time",
                                                $event
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function fn(_ref4) {
                                                  var on = _ref4.on,
                                                    attrs = _ref4.attrs
                                                  return [
                                                    _c(
                                                      "gg-text-field",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required",
                                                                expression:
                                                                  "'required'"
                                                              }
                                                            ],
                                                            attrs: {
                                                              placeholder:
                                                                "Select Stop Time",
                                                              "prepend-icon":
                                                                "mdi-clock-outline",
                                                              readonly: "",
                                                              "data-vv-name":
                                                                "Stop Time",
                                                              "data-vv-as":
                                                                "Stop Time",
                                                              "error-messages": _vm.errors.collect(
                                                                "Stop Time"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.dateEnd
                                                                  .time,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.dateEnd,
                                                                  "time",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "dateEnd.time"
                                                            }
                                                          },
                                                          "gg-text-field",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      )
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            1476311317
                                          ),
                                          model: {
                                            value: _vm.timeEndModal,
                                            callback: function callback($$v) {
                                              _vm.timeEndModal = $$v
                                            },
                                            expression: "timeEndModal"
                                          }
                                        },
                                        [
                                          _vm.timeEndModal
                                            ? _c("v-time-picker", {
                                                attrs: {
                                                  "full-width": ""
                                                },
                                                on: {
                                                  "click:minute": function clickMinute(
                                                    $event
                                                  ) {
                                                    return _vm.$refs.endTime.save(
                                                      _vm.dateEnd.time
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _vm.dateEnd.time,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.dateEnd,
                                                      "time",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "dateEnd.time"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isRangeCorrect
                            ? _c(
                                "v-alert",
                                {
                                  attrs: {
                                    type: "warning",
                                    dense: ""
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.error_msg) + " ")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "3",
                                    lg: "2"
                                  }
                                },
                                [
                                  _c("gg-input-label", [_vm._v("Time Delay")]),
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.rules.interval,
                                        expression: "rules.interval"
                                      }
                                    ],
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      "data-vv-name": "interval",
                                      "data-vv-as": "Interval",
                                      "error-messages": _vm.errors.collect(
                                        "interval"
                                      )
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "append-outer",
                                        fn: function fn() {
                                          return [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  top: ""
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "activator",
                                                    fn: function fn(_ref5) {
                                                      var on = _ref5.on
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g({}, on),
                                                          [
                                                            _vm._v(
                                                              " mdi-help-circle-outline "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ])
                                              },
                                              [
                                                _vm._v(
                                                  " Hours to wait before sending autoresponder to the same address "
                                                )
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ]),
                                    model: {
                                      value: _vm.model.interval,
                                      callback: function callback($$v) {
                                        _vm.$set(_vm.model, "interval", $$v)
                                      },
                                      expression: "model.interval"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.applyInitialModel
                  }
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    primary: "",
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.newResponder
                  }
                },
                [_vm.edit ? [_vm._v("Update")] : [_vm._v("Create")]],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }